var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 64,
    viewBox: "0 0 59 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5802 10.1525C37.8468 0.753055 22.3366 1.02379 12.9372 10.7572C3.53783 20.4905 3.80856 36.0007 13.5419 45.4001L28.2484 59.602C29.8596 61.1579 32.4271 61.1131 33.983 59.5019L48.1849 44.7954C57.5843 35.062 57.3136 19.5519 47.5802 10.1525Z",
    fill: "#B73438",
    stroke: "#B73438",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2304 14.7428C20.6358 18.416 18.2655 24.288 18.4561 30.9012C18.6097 36.2271 23.7843 41.6764 29.8682 41.969C35.2064 42.2258 40.8744 39.407 42.7278 33.128C44.5005 27.1237 42.3881 21.7809 38.7305 15.1162C37.597 15.1846 36.4241 15.1969 34.9362 16.1814C35.9543 18.7479 41.0885 24.759 37.3368 32.3745C35.3421 36.4233 30.042 38.8766 25.4448 34.5912C22.284 31.6446 23.2348 25.0718 25.0087 20.154C25.2206 20.2056 25.243 20.2269 25.4033 20.2605C25.9842 19.0877 26.806 17.0302 27.2142 16.0042C27.2074 15.5625 27.2142 15.3674 27.1547 14.9917C25.3394 15.1588 24.7754 14.8639 23.236 14.7417H23.2315L23.2304 14.7428Z",
    fill: "url(#paint0_linear_20934_14390)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.785 14.4258C20.1905 18.099 17.8202 23.9732 18.0108 30.5841C18.1621 35.9101 23.3389 41.3593 29.4229 41.652C34.7611 41.9088 40.4291 39.0899 42.2825 32.8109C44.0552 26.8066 42.4193 21.2217 38.7606 14.557C37.6271 14.6254 35.9799 14.8799 34.492 15.8643C35.5101 18.4309 40.6443 24.4419 36.8904 32.0574C34.8957 36.1063 29.5955 38.5596 24.9984 34.2742C20.9114 30.4642 23.922 20.5355 26.3439 16.0482C25.5366 15.1064 24.5824 14.5659 22.7884 14.4258H22.7862H22.785Z",
    fill: "url(#paint1_linear_20934_14390)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9335 16.1251C37.4233 16.2059 36.921 16.3303 36.4388 16.5142C36.6676 16.9268 36.9086 17.3361 37.1116 17.7106C37.7933 18.9686 38.4078 20.2435 38.8686 21.5991C40.1558 25.3912 39.9876 29.0947 38.2048 32.7096C38.0826 32.9574 37.9503 33.1984 37.8101 33.4339C36.7483 35.1976 35.1326 36.6418 33.2152 37.4054C31.4515 38.1084 30.864 40.4372 33.3162 39.7734C34.3948 39.4808 35.4286 39.0368 36.3761 38.4414C38.6186 37.032 40.1233 34.9285 40.8711 32.3979C42.5878 26.5786 40.6536 21.2425 37.9346 16.124V16.1263L37.9335 16.1251ZM27.7749 37.6206C26.4059 37.189 25.1232 36.4075 23.9907 35.3524C20.8748 32.4461 21.2706 27.193 22.1093 23.4133C22.6239 21.0923 23.457 18.5941 24.5155 16.392C24.2015 16.198 23.8663 16.0803 23.4929 16.0029C20.7705 20.2121 19.3353 25.5907 19.4766 30.5467C19.545 32.9641 20.8411 35.2918 22.5264 36.9703C23.8651 38.3046 25.5369 39.3283 27.3545 39.8407C30.1621 40.629 29.9468 38.308 27.7727 37.6218L27.7749 37.6195V37.6206Z",
    fill: "url(#paint2_linear_20934_14390)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9412 19.1481C37.5847 18.5998 36.9209 16.3293 36.4399 16.5109C36.6686 16.9235 36.9097 17.3328 37.1126 17.7073C37.7943 18.9653 38.4088 20.2402 38.8696 21.5958C40.1568 25.3878 39.9886 29.0913 38.2058 32.7062C38.0836 32.954 37.9513 33.1951 37.8112 33.4306C36.7493 35.1943 35.1336 36.6385 33.2163 37.402C32.2789 37.7754 31.6746 38.6085 31.6813 39.2061C31.8865 38.5244 32.3966 38.0165 33.3688 37.6072C35.2054 36.8325 38.2911 34.942 39.4717 30.0567C40.4663 25.9417 39.7386 22.8135 37.9446 19.1425L37.9424 19.1492L37.9412 19.1481ZM19.7478 29.3941C19.9149 27.0215 19.7758 24.5727 22.2908 18.2881C22.9053 17.2229 23.8729 16.0781 23.4973 16.0007C20.7749 20.2099 19.3397 25.5885 19.481 30.5445C19.5494 32.9619 20.8455 35.2896 22.5308 36.9681C23.8695 38.3024 25.5413 39.3261 27.3589 39.8385C23.6307 38.5356 19.3744 34.6875 19.7478 29.3941Z",
    fill: "url(#paint3_linear_20934_14390)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8991 37.5424C26.2647 37.5424 26.5607 37.835 26.5629 38.2005C26.5629 38.5661 26.2703 38.8621 25.9047 38.8643C25.5392 38.8643 25.2432 38.5717 25.241 38.2061C25.241 37.8406 25.5336 37.5446 25.8991 37.5424Z",
    fill: "url(#paint4_radial_20934_14390)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9172 37.2841C35.2827 37.2841 35.5787 37.5767 35.581 37.9422C35.581 38.3078 35.2883 38.6038 34.9228 38.606C34.5573 38.606 34.2613 38.3134 34.259 37.9478C34.259 37.5823 34.5517 37.2863 34.9172 37.2841Z",
    fill: "url(#paint5_radial_20934_14390)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3095 34.3688C22.6515 34.3688 22.9284 34.6424 22.9284 34.9821C22.9284 35.3219 22.6549 35.5988 22.314 35.6011C21.9743 35.6011 21.6973 35.3275 21.6951 34.9866C21.6951 34.6469 21.9687 34.3699 22.3084 34.3677L22.3106 34.3699L22.3095 34.3688Z",
    fill: "url(#paint6_radial_20934_14390)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0969 34.2985C38.4388 34.2985 38.7136 34.5721 38.7158 34.9118C38.7158 35.2515 38.4422 35.5285 38.1014 35.5307C37.7616 35.5307 37.4847 35.2572 37.4824 34.9163C37.4824 34.5766 37.756 34.2996 38.0957 34.2974L38.098 34.2996L38.0969 34.2985Z",
    fill: "url(#paint7_radial_20934_14390)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5367 30.756C20.8081 30.756 21.0278 30.9735 21.0301 31.2448C21.0301 31.5162 20.8125 31.736 20.5412 31.7382C20.2699 31.7404 20.0501 31.5207 20.0479 31.2493C20.0479 30.978 20.2654 30.7582 20.5367 30.756Z",
    fill: "url(#paint8_radial_20934_14390)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1061 30.6213C40.3774 30.6213 40.5972 30.8389 40.5994 31.1102C40.5994 31.3815 40.3819 31.6013 40.1105 31.6036C39.8392 31.6058 39.6194 31.386 39.6172 31.1147C39.6172 30.8433 39.8347 30.6236 40.1061 30.6213Z",
    fill: "url(#paint9_radial_20934_14390)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6142 27.1931C20.8788 27.1931 21.093 27.405 21.0952 27.6696C21.0952 27.9343 20.8833 28.1484 20.6187 28.1507C20.3541 28.1529 20.1399 27.9387 20.1377 27.6741C20.1377 27.4118 20.3496 27.1954 20.6142 27.1931Z",
    fill: "url(#paint10_radial_20934_14390)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1688 23.2501C21.4233 23.2501 21.6296 23.4531 21.6319 23.7076C21.6319 23.9621 21.4267 24.1684 21.1733 24.1707C20.9199 24.1729 20.7124 23.9655 20.7102 23.7121C20.7102 23.4576 20.9154 23.2512 21.1688 23.2512V23.2501Z",
    fill: "url(#paint11_radial_20934_14390)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1194 19.8806C22.3526 19.8806 22.5399 20.0667 22.5399 20.2988C22.5399 20.5309 22.3537 20.7193 22.1216 20.7193C21.8895 20.7193 21.7012 20.5332 21.7012 20.3033C21.7012 20.0735 21.8873 19.8829 22.1194 19.8829V19.8806Z",
    fill: "url(#paint12_radial_20934_14390)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6303 27.1035C40.895 27.1035 41.1091 27.3154 41.1114 27.58C41.1114 27.8447 40.8994 28.0588 40.6348 28.0611C40.3725 28.0611 40.1561 27.8491 40.1538 27.5845C40.1538 27.3222 40.3657 27.1058 40.6303 27.1035Z",
    fill: "url(#paint13_radial_20934_14390)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2218 23.1968C40.4763 23.1968 40.6827 23.402 40.6827 23.6554C40.6827 23.9088 40.4797 24.1162 40.2241 24.1184C39.9695 24.1184 39.7632 23.9133 39.761 23.6599C39.761 23.4053 39.9662 23.199 40.2196 23.199L40.2218 23.1968Z",
    fill: "url(#paint14_radial_20934_14390)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0976 19.8268C39.3308 19.8268 39.5181 20.0129 39.5203 20.245C39.5203 20.476 39.3342 20.6655 39.1021 20.6655C38.87 20.6655 38.6816 20.4794 38.6816 20.2495C38.6816 20.0196 38.8678 19.829 39.0999 19.829L39.0976 19.8268Z",
    fill: "url(#paint15_radial_20934_14390)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3802 12.9999C24.0027 13.5829 25.5881 14.2624 27.1489 14.9923C26.6107 16.635 25.8998 18.2036 25.1542 19.7588C23.5115 19.2206 21.9407 18.5119 20.3855 17.7663C20.9472 16.1304 21.592 14.5057 22.3802 12.9999Z",
    fill: "url(#paint16_linear_20934_14390)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4715 13.9037C21.9827 14.9308 21.5443 15.9904 21.1541 17.0601C21.0711 17.2865 21.1417 17.5837 21.4277 17.7182C22.4424 18.197 23.4627 18.6679 24.5245 19.0234C24.7589 19.1019 24.982 18.9785 25.0414 18.8563C25.5471 17.7967 25.9485 16.6934 26.415 15.6148C26.5047 15.4051 26.3511 15.1595 26.1548 15.0721C25.0897 14.5978 24.0211 14.1347 22.9324 13.7243C22.753 13.6559 22.5803 13.6817 22.4749 13.9037H22.4727H22.4715Z",
    fill: "url(#paint17_radial_20934_14390)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8687 15.7309C35.2758 14.8361 36.7323 14.0311 38.2169 13.2709C39.152 14.6545 39.9313 16.1256 40.6791 17.6168C39.2955 18.552 37.8222 19.3312 36.3309 20.0769C35.4126 18.6798 34.5537 17.2244 33.8687 15.7309Z",
    fill: "url(#paint18_linear_20934_14390)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6419 14.1237C36.6978 14.6316 35.7795 15.1552 34.8321 15.717C34.6571 15.819 34.5775 16.078 34.6762 16.2866C35.1292 17.2475 35.6842 18.1613 36.2538 19.0606C36.3738 19.2489 36.6664 19.3655 36.9389 19.2186C37.8292 18.7421 38.7217 18.2667 39.5828 17.7408C39.8048 17.6063 39.9865 17.3495 39.8115 17.0064C39.3507 16.0971 38.8506 15.2079 38.3192 14.339C38.1723 14.1001 37.9177 13.9757 37.6397 14.1259L37.6419 14.1237Z",
    fill: "url(#paint19_radial_20934_14390)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6648 33.058L24.6134 36.1784L25.8176 29.479L20.9761 24.689L27.7249 23.7628L30.7848 17.6812L33.7527 23.8099L40.4836 24.8415L35.5703 29.5541L36.6691 36.2737L30.6648 33.058Z",
    fill: "#231F20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6683 36.2744L35.5684 29.5558L40.4817 24.841L33.7508 23.8094L30.7851 17.6807L27.723 23.7623L20.9775 24.6896L25.8169 29.4796L24.6126 36.1802L30.664 33.0586L36.6672 36.2744H36.6694H36.6683ZM25.8438 34.5129L26.7195 29.6422L26.8047 29.1679L26.4605 28.8281L22.9409 25.3455L27.8463 24.6728L28.3251 24.6066L28.5426 24.1749L30.7672 19.7527L32.9256 24.2097L33.1353 24.6459L33.6118 24.7188L38.5061 25.4678L34.9338 28.8954L34.5862 29.2284L34.6646 29.705L35.4652 34.5891L31.1002 32.2524L30.6752 32.0237L30.2458 32.2457L25.8449 34.5151L25.8426 34.5129H25.8438Z",
    fill: "#231F20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7876 17.3867L27.6392 23.6388L27.8107 23.8832L27.8399 23.8205L30.7831 17.9765L30.7854 17.981L30.7899 17.3867H30.7876Z",
    fill: "#231F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8398 23.6904L30.7889 17.3867L30.7844 17.981L33.6649 23.9292L33.8421 23.6904H33.8398Z",
    fill: "#231F20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7653 24.752L33.8427 23.6902L33.6655 23.929L40.2013 24.9314L40.763 24.7543L40.7653 24.752Z",
    fill: "#231F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7632 24.7542L40.2015 24.9313L35.4294 29.5071L35.4317 29.5161L35.7109 29.6092V29.6013L40.7632 24.7542Z",
    fill: "#231F20"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.497 36.0241V36.0309L30.6677 32.9093L30.6632 32.9138L30.6587 33.2076L30.6654 33.2064L36.8435 36.5141L36.8413 36.5074L36.497 36.0241Z",
    fill: "#231F20"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7108 29.6097L35.4316 29.5166L36.4968 36.0243L36.8411 36.5076L35.7108 29.6097Z",
    fill: "#231F20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.259 24.7831L27.7421 23.8906L27.8105 23.8827L27.6389 23.6383V23.6405L20.6973 24.5959L20.7062 24.6037L21.2669 24.7921L21.259 24.7831Z",
    fill: "#231F20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9597 29.4343L25.6749 29.5218L25.6772 29.524L24.4404 36.4007L24.7936 35.9286L25.9597 29.4343Z",
    fill: "#231F20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7893 35.9417L24.7938 35.9294L24.4406 36.4014L24.4395 36.4182L30.659 33.2081L30.6635 32.9143L24.7893 35.9417Z",
    fill: "#231F20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2667 24.7926L20.7061 24.6042L25.6743 29.5221L25.9591 29.4346L21.2667 24.7926Z",
    fill: "#231F20"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2234 25.437L27.8676 24.8002L28.3441 24.734L28.4103 24.7262L28.2398 24.4851L27.8317 24.5423L22.6616 25.2509L22.6706 25.2576L23.2301 25.4438L23.2234 25.437Z",
    fill: "#231F20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9446 29.1233L23.2299 25.4444L22.6704 25.2583L26.6654 29.213L26.6632 29.2152L26.9446 29.1277V29.1233Z",
    fill: "#231F20"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9452 29.1272L26.6637 29.2147L25.6692 34.748L26.0213 34.2737L26.9452 29.1272Z",
    fill: "#231F20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0213 34.276V34.2738L25.6692 34.7481V34.7492L30.6677 32.1726L30.6722 31.8777L26.0213 34.276Z",
    fill: "#231F20"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7718 19.4565L28.425 24.1176L28.2411 24.4854H28.24L28.4104 24.7264H28.4127L28.4441 24.6648L28.6605 24.2331L30.7673 20.0497L30.7718 19.4577V19.4565Z",
    fill: "#231F20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2265 24.5227L30.7721 19.4569L30.7676 20.0489L33.0482 24.7615L33.2265 24.5227Z",
    fill: "#231F20"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2904 34.3382L35.2926 34.3472L30.6764 31.876L30.672 31.8782L30.6675 32.1731L30.6742 32.1709L35.6369 34.8294V34.8204L35.2904 34.3382Z",
    fill: "#231F20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7287 29.2807L34.4473 29.1865L35.2904 34.3375L35.6369 34.8197L34.7287 29.2807Z",
    fill: "#231F20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2259 24.5234L33.051 24.76L38.2121 25.5505L38.7806 25.3733C38.5283 25.3352 33.3571 24.5425 33.2259 24.5234Z",
    fill: "#231F20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7799 25.376L38.2115 25.5531H38.226L34.4463 29.1815V29.1882L34.7277 29.2824V29.2757L38.7889 25.3782H38.7777V25.376H38.7799Z",
    fill: "#231F20"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5494 18.1609C31.5449 18.5836 31.1996 18.9256 30.7769 18.9211C30.3541 18.9188 30.0122 18.5735 30.0166 18.1497C30.0189 17.7269 30.3665 17.385 30.7892 17.3894C31.2119 17.3939 31.5539 17.7393 31.5494 18.162V18.1597V18.1609Z",
    fill: "#231F20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9207 25.0928C40.9185 25.5155 40.5709 25.8575 40.1482 25.853C39.7255 25.8485 39.3835 25.5032 39.3858 25.0804C39.3902 24.6577 39.7356 24.3157 40.1583 24.3202C40.581 24.3247 40.923 24.6701 40.9185 25.0928H40.9207Z",
    fill: "#231F20"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2486 35.9758C37.2464 36.3986 36.8988 36.7405 36.4761 36.7361C36.0534 36.7338 35.7114 36.3885 35.7136 35.9635C35.7181 35.5408 36.0635 35.1988 36.4862 35.2011C36.9089 35.2055 37.2509 35.5509 37.2464 35.9736L37.2486 35.9758Z",
    fill: "#231F20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8111 35.792C25.8089 36.2147 25.4613 36.5567 25.0386 36.5522C24.6159 36.55 24.2739 36.2046 24.2784 35.7797C24.2806 35.357 24.6282 35.015 25.0509 35.0195C25.4736 35.0217 25.8156 35.3693 25.8111 35.792Z",
    fill: "#231F20"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9715 24.8489C21.967 25.2716 21.6217 25.6136 21.199 25.6091C20.774 25.6068 20.4343 25.2615 20.4365 24.8365C20.441 24.4138 20.7864 24.0719 21.2091 24.0763C21.6318 24.0808 21.9738 24.4262 21.9693 24.8489H21.9715Z",
    fill: "#231F20"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30.667 32.7637L24.9117 35.7328L26.0565 29.3607L21.4548 24.8073L27.8695 23.926L30.7803 18.1426L33.6013 23.9708L40.0026 24.9508L35.3303 29.4325L36.3753 35.8225L30.667 32.7637Z",
    fill: "url(#paint20_radial_20934_14390)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3754 35.8218L35.3292 29.4329L40.0015 24.9502L33.5991 23.9702L30.7781 18.1431L27.8673 23.9254L21.4526 24.8078L26.0543 29.3623L24.9095 35.7344L30.6648 32.7664L36.3731 35.8241L36.3754 35.8218ZM26.0823 34.1478L26.9154 29.5159L26.9961 29.0652L26.6698 28.7423L23.324 25.4301L27.9873 24.7898L28.4425 24.7282L28.6477 24.3178L30.7635 20.1131L32.8154 24.3503L33.0161 24.7641L33.4691 24.8324L38.1245 25.5456L34.7271 28.8039L34.3964 29.1224L34.4715 29.5753L35.2317 34.2196L31.0808 31.9961L30.6772 31.7786L30.269 31.9883L26.0856 34.1467H26.0834L26.0823 34.1478Z",
    fill: "url(#paint21_radial_20934_14390)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7823 17.8597L27.7886 23.8069L27.9523 24.0378L27.9803 23.9795L30.7778 18.4215L30.7801 18.426L30.7846 17.862L30.7823 17.8597Z",
    fill: "url(#paint22_linear_20934_14390)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6866 23.856L30.7848 17.8618L30.7803 18.4258L33.5173 24.0825H33.5195L33.6866 23.856Z",
    fill: "url(#paint23_linear_20934_14390)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M40.269 24.8646L33.6861 23.8555L33.519 24.082L39.733 25.0339L40.2679 24.8668L40.269 24.8646Z",
    fill: "url(#paint24_linear_20934_14390)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2676 24.8674L39.7328 25.0345L35.1951 29.3883L35.1973 29.395L35.4642 29.4825L35.4619 29.4758L40.2676 24.8674Z",
    fill: "url(#paint25_linear_20934_14390)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2096 35.5838L36.2119 35.5905L30.6684 32.6226L30.6617 32.6248L30.6594 32.9062L30.6639 32.904L36.5381 36.0491L36.5359 36.0435L36.2096 35.5838Z",
    fill: "url(#paint26_linear_20934_14390)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4641 29.4828L35.1973 29.3954L36.2098 35.5836L36.536 36.0433L35.4641 29.4828Z",
    fill: "url(#paint27_linear_20934_14390)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7212 24.8959L27.8859 24.0482L27.9498 24.0392L27.952 24.0381L27.7883 23.8071V23.8094L21.1875 24.7165L21.1965 24.7254L21.7302 24.9026L21.7212 24.8959Z",
    fill: "url(#paint28_linear_20934_14390)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1911 29.3179V29.3157L25.9198 29.3998L25.922 29.402L24.748 35.9423L25.0811 35.4915L26.1911 29.3179Z",
    fill: "url(#paint29_linear_20934_14390)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0784 35.5052L25.0806 35.4918L24.7476 35.9425L24.7454 35.9571L30.66 32.9062L30.6622 32.6248L25.0784 35.5052Z",
    fill: "url(#paint30_linear_20934_14390)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M21.73 24.9023L21.1963 24.7251L25.919 29.3996L26.1903 29.3155L21.73 24.9023Z",
    fill: "url(#paint31_linear_20934_14390)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5889 25.5162L28.0055 24.9096L28.4585 24.8479L28.5202 24.8401L28.3576 24.6113L27.9707 24.664L23.0552 25.339L23.0619 25.3457L23.5956 25.5229L23.5889 25.5162Z",
    fill: "url(#paint32_linear_20934_14390)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1301 29.0201L23.596 25.5241L23.0623 25.3469L26.8611 29.1054V29.1098L27.1279 29.0257L27.1301 29.0201Z",
    fill: "url(#paint33_linear_20934_14390)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1282 29.0251L26.8614 29.1092L25.915 34.3679L26.2492 33.9205L27.1282 29.0251Z",
    fill: "url(#paint34_linear_20934_14390)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2492 33.9206L25.915 34.368V34.3725L30.6691 31.9214L30.6714 31.64L26.2492 33.9206Z",
    fill: "url(#paint35_linear_20934_14390)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7661 19.8307L28.5371 24.2619L28.3599 24.6117H28.3577L28.5202 24.8404H28.5225L28.5528 24.7799L28.7591 24.3729L30.7628 20.3924V20.3936L30.7661 19.8307Z",
    fill: "url(#paint36_linear_20934_14390)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1015 24.6476L30.767 19.8307L30.7637 20.3936L32.9333 24.8741L33.1015 24.6476Z",
    fill: "url(#paint37_linear_20934_14390)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0629 33.9796L35.0651 33.9875L30.6754 31.6373L30.6709 31.6396L30.6687 31.921L30.6732 31.9188L35.3925 34.4449V34.4382L35.0629 33.9796Z",
    fill: "url(#paint38_linear_20934_14390)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5291 29.171L34.2622 29.0813L35.0628 33.98L35.3924 34.4386L34.5291 29.171Z",
    fill: "url(#paint39_linear_20934_14390)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1007 24.6477L32.9336 24.8742L37.8424 25.6254L38.3829 25.4572C38.144 25.4214 33.2262 24.6668 33.1018 24.6477H33.0995H33.1007Z",
    fill: "url(#paint40_linear_20934_14390)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3817 25.4568L37.8412 25.625H37.8558L34.2622 29.0739V29.0807L34.5313 29.1704V29.1636L38.394 25.459H38.3828L38.3806 25.4568H38.3817Z",
    fill: "url(#paint41_linear_20934_14390)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5061 18.2689C31.5016 18.6703 31.1731 18.9955 30.7717 18.991C30.3681 18.9887 30.0451 18.6602 30.0474 18.2566C30.0496 17.8529 30.3781 17.53 30.7818 17.5322C31.1832 17.5345 31.5084 17.8652 31.5061 18.2667V18.2689Z",
    fill: "url(#paint42_radial_20934_14390)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.751 25.0232C40.7488 25.4269 40.418 25.7498 40.0166 25.7476C39.6129 25.7431 39.2889 25.4146 39.2923 25.0132C39.2967 24.6095 39.6253 24.2866 40.0267 24.2888C40.4281 24.2933 40.7533 24.6218 40.751 25.0232Z",
    fill: "url(#paint43_radial_20934_14390)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0943 35.868C37.092 36.2716 36.7613 36.5945 36.3598 36.5923C35.9562 36.5901 35.6322 36.2615 35.6355 35.8579C35.6378 35.4565 35.9685 35.1313 36.3699 35.1336C36.7736 35.138 37.0965 35.4666 37.0943 35.868Z",
    fill: "url(#paint44_radial_20934_14390)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7195 35.6976C25.7173 36.1013 25.3865 36.4242 24.9851 36.4197C24.5814 36.4175 24.2585 36.0889 24.2608 35.6853C24.263 35.2816 24.5938 34.9587 24.9952 34.9609C25.3966 34.9632 25.7217 35.294 25.7195 35.6954V35.6976Z",
    fill: "url(#paint45_radial_20934_14390)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0659 24.7947C22.0615 25.1984 21.7329 25.5224 21.3315 25.5191C20.9279 25.5168 20.6049 25.186 20.6072 24.7846C20.6094 24.381 20.9402 24.0581 21.3416 24.0603C21.7453 24.0648 22.0682 24.3933 22.0659 24.7947Z",
    fill: "url(#paint46_radial_20934_14390)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20934_14390",
    x1: 18.4373,
    y1: 28.4016,
    x2: 43.3625,
    y2: 28.2928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#50180E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B77228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A26224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#80481E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#512415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#391211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3B1311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#431A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#512514"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#653517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7F491A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9F621F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C47F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA9027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20934_14390",
    x1: 28.0034,
    y1: 17.5209,
    x2: 33.2834,
    y2: 40.9232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EEBA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EFC063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F2CA72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F5D888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FAE9A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FDF4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#BF782A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20934_14390",
    x1: 26.0446,
    y1: 15.6553,
    x2: 36.5578,
    y2: 45.3421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50180E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#EEB958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F4CD6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FDE782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F8D369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F4C153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F1BC4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBB044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E09C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DA9027"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20934_14390",
    x1: 24.9432,
    y1: 19.0197,
    x2: 36.4324,
    y2: 39.0354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B5825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A46026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#BD7629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#A76625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6B381A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.4519 38.946) rotate(-0.25) scale(1.1356 1.1356)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1878 66.552) scale(1.33877 1.33877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.84681 63.287) scale(1.02931)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3495 63.4106) scale(1.18965)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.95291 59.2727) scale(0.87794 0.877939)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2925 59.2726) scale(0.916063 0.916061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.11895 55.6224) scale(1.00801 1.008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.6612 51.3711) scale(0.91158 0.911577)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.56591 47.8457) scale(0.779267 0.77927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0097 55.6125) scale(1.11452 1.11452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5104 51.4848) scale(0.999031 0.999034)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3458 47.8031) scale(0.890271 0.890273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8832A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BB7827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#995E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#633318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_20934_14390",
    x1: 22.1436,
    y1: 20.0887,
    x2: 25.2475,
    y2: 12.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50180E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EEB958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EEBB5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F0CE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#F2DB7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F3E286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5756 16.4709) rotate(-0.25) scale(5.09998 5.09999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9A5C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#77411C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5C2C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#481D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_20934_14390",
    x1: 35.7673,
    y1: 14.2555,
    x2: 39.139,
    y2: 19.6599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50180E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#EEB958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EEBB5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F0CE6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F2DB7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F3E286"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#BF782A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3656 16.7575) rotate(-0.25) scale(4.7437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F4E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F4E285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F4DC7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F4D267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F5D165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BF782A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9A5C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#77411C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5C2C17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#481D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3C1411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#391211"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7408 21.4263) rotate(-179.55) scale(17.2978)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.678 18.5133) rotate(-0.15) scale(26.8674 26.8674)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_20934_14390",
    x1: 29.2632,
    y1: 20.8571,
    x2: 33.0161,
    y2: 24.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E5DAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A68E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82632C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_20934_14390",
    x1: 29.9069,
    y1: 16.3118,
    x2: 34.1138,
    y2: 25.0426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_20934_14390",
    x1: 35.2139,
    y1: 20.8291,
    x2: 38.3571,
    y2: 27.6443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_20934_14390",
    x1: 33.8785,
    y1: 22.2185,
    x2: 38.3924,
    y2: 27.9726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_20934_14390",
    x1: 35.0556,
    y1: 28.7946,
    x2: 33.8361,
    y2: 33.4384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_20934_14390",
    x1: 32.5842,
    y1: 30.6789,
    x2: 37.9909,
    y2: 33.9765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_20934_14390",
    x1: 24.5817,
    y1: 24.4143,
    x2: 25.7582,
    y2: 28.0969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E5DAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A68E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82632C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_20934_14390",
    x1: 23.444,
    y1: 30.5711,
    x2: 28.5533,
    y2: 35.7613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_20934_14390",
    x1: 24.6987,
    y1: 31.235,
    x2: 26.9825,
    y2: 33.5572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_20934_14390",
    x1: 23.7319,
    y1: 22.0918,
    x2: 23.6931,
    y2: 27.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_20934_14390",
    x1: 23.4679,
    y1: 22.7015,
    x2: 26.2389,
    y2: 25.5152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_20934_14390",
    x1: 22.3639,
    y1: 24.4062,
    x2: 27.8514,
    y2: 29.9828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_20934_14390",
    x1: 24.4439,
    y1: 29.5854,
    x2: 29.5543,
    y2: 34.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_20934_14390",
    x1: 27.8402,
    y1: 32.4513,
    x2: 30.6778,
    y2: 35.9227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_20934_14390",
    x1: 27.8237,
    y1: 20.1974,
    x2: 30.4557,
    y2: 23.2893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_20934_14390",
    x1: 29.2159,
    y1: 18.0835,
    x2: 33.9924,
    y2: 25.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_20934_14390",
    x1: 27.5674,
    y1: 29.4392,
    x2: 36.0952,
    y2: 35.0902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F1E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#CFBF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#987D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#A17E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#C49E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#DEB51E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#EDC31B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_20934_14390",
    x1: 32.7274,
    y1: 30.4433,
    x2: 38.1352,
    y2: 33.7398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E5DAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A68E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82632C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_20934_14390",
    x1: 34.143,
    y1: 21.3842,
    x2: 35.9543,
    y2: 25.9026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#87682B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#987628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B38F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#D8B01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C81B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_20934_14390",
    x1: 35.9767,
    y1: 26.8891,
    x2: 39.1065,
    y2: 30.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E5DAA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#A68E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82632C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.6308 17.9702) rotate(0.45) scale(1.27877 1.27876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2493 1.47587) scale(1.33429 1.33429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.522 12.8319) scale(1.33428 1.33429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6471 12.7467) scale(1.33429 1.33429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_20934_14390",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7458 1.39088) scale(1.33429 1.33429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FCF6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F5EDB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E8DEA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#D7C990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#C0AD75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A48C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#82632C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A27F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#D4AC20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F3C71C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD21B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/mapIcon.47d39201fe0cc4212955c5a3c479931e.svg";
export { ForwardRef as ReactComponent };